import Helpers from '../../../../utils/helper';

export interface DocumentSection {
    id: string;
    name: string;
    isLetterSection: boolean;
    index: number;
    isAvailableForBuyers: boolean;
}

export const GenerateDocumentSectionList = (): DocumentSection[] => [
    {
        id: Helpers.generateGUID(),
        name: 'Engagement Agreements',
        isLetterSection: true,
        index: 1,
        isAvailableForBuyers: false,
    },
    {
        id: Helpers.generateGUID(),
        name: 'Stage 1 NDA (Identification)',
        isLetterSection: false,
        index: 2,
        isAvailableForBuyers: false,
    },
    {
        id: Helpers.generateGUID(),
        name: 'Stage 2 NDA (data / restrictive covenants)',
        isLetterSection: false,
        index: 3,
        isAvailableForBuyers: false,
    },
    {
        id: Helpers.generateGUID(),
        name: 'Informational Documents',
        isLetterSection: false,
        index: 4,
        isAvailableForBuyers: false,
    },
];
